import { ApiErrorDTO } from "@bvhi/backend-api/apis";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@bvhi/ui-base";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useKeyboardShortcut } from "../hooks/use-keyboard-shortcuts";
import { DialogError } from "./dialog-error";
import { getAppConfig } from "../config/config.ts";

interface Props {
  error?: ApiErrorDTO;
  open: boolean;
  onClose: () => void;
}

export const ErrorDialog = ({ error, open, onClose }: Props) => {
  const { t } = useTranslation(["dialogs", "errors"]);

  const primaryButtonRef = useRef<HTMLButtonElement>(null);
  useKeyboardShortcut({
    key: "Enter",
    onKeyPressed: () => primaryButtonRef.current?.click(),
  });

  let isNotInProduction = false;
  if (getAppConfig().env.stage === "stage-dev") isNotInProduction = true;
  if (getAppConfig().env.stage === "stage-test") isNotInProduction = true;
  if (getAppConfig().env.stage === "local-dev") isNotInProduction = true;

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>{t("dialogs:error.dialog.title")}</DialogTitle>
      <DialogError error={error} />
      {isNotInProduction && error && (
        <>
          <DialogTitle>{t("errors:errors.api.error.title")}</DialogTitle>
          <DialogContent sx={{ maxHeight: 500 }}>
            <pre>
              <code>{JSON.stringify(error, null, 2)}</code>
            </pre>
          </DialogContent>
        </>
      )}
      <DialogActions>
        <Button ref={primaryButtonRef} color="primary" onClick={onClose} variant="contained">
          {t("dialogs:dialogs.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
